import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { logListenerError } from 'features/firebase/services/listenerErrorLog';
import { listenForFirestoreDocumentSnapshots } from 'features/firebase/services/subscriptionService';
import { getParticipationDocumentPath } from 'features/participations/services/participationDocumentService';
import { documentNotFound, snapshotReceived } from './participationSlice';
import type { DbParticipation } from '@hub/common';

type Params = {
  userId: string;
  participationId: string;
};

export const participationDocumentApi = createApi({
  reducerPath: 'participationDocumentApi',
  baseQuery: fakeBaseQuery(),
  tagTypes: ['participation'],
  endpoints: builder => ({
    participationSubscription: builder.query<null, Params>({
      providesTags: ['participation'],
      keepUnusedDataFor: 3600,
      queryFn() {
        return { data: null };
      },
      async onCacheEntryAdded(params, { dispatch, cacheEntryRemoved }) {
        const documentPath = getParticipationDocumentPath(
          params.userId,
          params.participationId
        );

        const onSnapshot = (data: DbParticipation) => {
          dispatch(snapshotReceived(data));
        };

        const onError = (error: Error) => {
          logListenerError('Error in participation snapshot listener', error);
          // TODO: Consider adding error state
        };

        const onSnapshotEmpty = () => {
          dispatch(documentNotFound());
        };

        await listenForFirestoreDocumentSnapshots(
          cacheEntryRemoved,
          documentPath,
          onSnapshot,
          onError,
          onSnapshotEmpty
        );
      },
    }),
  }),
});

export const { useParticipationSubscriptionQuery } = participationDocumentApi;
